import Content from '../content-interface'

export default class FieldUpdatedHistory implements Content {
  name: string;

  current: string;

  previous: string;

  businessUnitName: string | null;

  constructor(obj: any = {}) {
    this.name = obj.name || '';
    this.current = obj.current || '';
    this.previous = obj.previous || '';
    this.businessUnitName = obj.businessUnitName || null;
  }

  public static of(obj: any = {}): FieldUpdatedHistory {
    return new FieldUpdatedHistory(obj);
  }
}
